module.exports = __webpack_public_path__ + "static/img/12.c8f97d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/12.png
// module id = A5sE
// module chunks = 0